require("./myProfileService");

'use strict';

angular.module('app.myProfile.myProfileController', [
  'app.myProfile.myProfileService'
])
  .controller('app.myProfile.myProfileController', [
    '$scope', 'app.myProfile.myProfileService', '$filter', '$state', '$timeout', '$stateParams',
    function ($scope, myProfile, $filter, $state, $timeout, $stateParams) {
      $scope.myProfile = myProfile;
      $scope.bio_expanded = false;
      $scope.stateParams = $stateParams;

      $scope.editting = {
        user_name: false,
        bio: false,
        address: false,
        is_profile_public: false
      };

      $scope.maxBioLength = 190;
      $scope.bioInputLength = 0;

      $scope.updateBioInputCounter = function (dat) {
        if (typeof dat === 'string') {
          $scope.bioInputLength = dat.length;
        } else {
          $scope.bioInputLength = 0;
        }
      };

      $scope.publicPrivateRadioOptions = [
        {value: true, text: 'public'},
        {value: false, text: 'private'}
      ];

      $scope.bioEformEditing = false;

      $scope.saveXeditable = function (field) {
        myProfile.save(field)
          .then((response) => {
            let data = response.data;
            if (data.error) {
              alert(data.error);
            }
          });
      };

      $scope.toggleForm = function (form) {
        if (form.$visible) {
          form.$submit();
        }
        else {
          form.$show();
        }
      };

      $scope.upload = function (file) {
        myProfile.save_image(file);
      };

      let init = function () {
        return myProfile.retrieve($scope.stateParams.username);
      };

      return init();
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/myProfile/myProfileController.js